import React from "react";
import "./App.css";
import PeriodicTable from "./PeriodicTable";
// import Video from "./Video";

function App() {

  return (

    <>
      <div className="App">
        <h1>Phase Prediction of Multiprincipal Element Alloys using
Ensemble Learning</h1>
        <PeriodicTable />
        {/* <Video /> */}
      </div>
      </>
  );
}

export default App;
